import store from '@/store'


export function DownloadDocumentFrom64(base64Data: string | undefined | null, name: string, extension: string) {
  if(base64Data === undefined || base64Data === null || !name || !extension) {
    throw new Error('Could not download file');
  }

  DownloadDocumentFromBytes(Base64ToArrayBuffer(base64Data), name, extension)
}

export function DownloadDocumentFromBytes(data: Uint8Array, name: string, extension: string) {
  if(!data || !name || !extension) {
    throw new Error('Could not download file');
  }

  saveByteArray(data, name + '.' + extension, extensionToMimeType(extension))
}

export function pathToFileFullName(path: string): string {
  let match = /(\d{8})-(.{32})-(.*)/g.exec(path);
  if(match && match.length > 0) return match[match.length - 1]
  return path;
}

export function sizeToString(size: number, precision: number = 2): string {
  const thresh = 1024;

  if (Math.abs(size) < thresh) return size + ' B';

  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] ;
  let u = -1;
  const r = 10**precision;

  do {
    size /= thresh;
    ++u;
  } while (Math.round(Math.abs(size) * r) / r >= thresh && u < units.length - 1);


  return size.toFixed(precision) + ' ' + units[u];
}

function Base64ToArrayBuffer(base64:any): Uint8Array {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i += 1) {
      bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

function saveByteArray(byte: Uint8Array, name: string, mimeType: string) {
  var blob = new Blob([byte], {type: mimeType});
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  var fileName = name;
  link.download = fileName;
  link.click();
};

function extensionToMimeType(ext: string): string {
  if(ext === 'pdf') return 'application/pdf'
  else return ext
}
